// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Topbar  */
.header-block {
    width: 100%;
    height: 60px;
    border-top: 4px solid #2D6DF6;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
    z-index: 1120;
}


.header-block .span {
    width: fit-content;
}

.header-block .span {
    background-color: white;
    color: black;
    border: none;
}

.header-block .span:hover {
    background-color: #2D6DF6;
    color: white;
}

/* topbar css */



/* Override PrimeReact Dialog styles */
.custom-dialog .p-dialog {
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(44, 62, 80, 0.15);
    background: #f9fafd;
}

.custom-dialog .p-dialog-header {
    background: #2D6DF6;
    color: #fff;
    font-weight: bold;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.custom-dialog .p-dialog-content {
    display: block !important;      /* Remove flexbox */
    align-items: unset !important;  /* Remove center alignment */
    justify-content: unset !important;
    padding: 2rem;                  /* Optional: your custom padding */
    background: #fff;               /* Optional: your custom background */
}

.custom-dialog .p-dialog-footer {
    background: #f1f3f6;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/layout.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,2CAA2C;IAC3C,aAAa;AACjB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,eAAe;;;;AAIf,sCAAsC;AACtC;IACI,mBAAmB;IACnB,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB,OAAO,mBAAmB;IACnD,6BAA6B,GAAG,4BAA4B;IAC5D,iCAAiC;IACjC,aAAa,mBAAmB,kCAAkC;IAClE,gBAAgB,gBAAgB,qCAAqC;AACzE;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,gCAAgC;AACpC","sourcesContent":["/* Topbar  */\n.header-block {\n    width: 100%;\n    height: 60px;\n    border-top: 4px solid #2D6DF6;\n    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);\n    z-index: 1120;\n}\n\n\n.header-block .span {\n    width: fit-content;\n}\n\n.header-block .span {\n    background-color: white;\n    color: black;\n    border: none;\n}\n\n.header-block .span:hover {\n    background-color: #2D6DF6;\n    color: white;\n}\n\n/* topbar css */\n\n\n\n/* Override PrimeReact Dialog styles */\n.custom-dialog .p-dialog {\n    border-radius: 16px;\n    box-shadow: 0 8px 32px rgba(44, 62, 80, 0.15);\n    background: #f9fafd;\n}\n\n.custom-dialog .p-dialog-header {\n    background: #2D6DF6;\n    color: #fff;\n    font-weight: bold;\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n}\n\n.custom-dialog .p-dialog-content {\n    display: block !important;      /* Remove flexbox */\n    align-items: unset !important;  /* Remove center alignment */\n    justify-content: unset !important;\n    padding: 2rem;                  /* Optional: your custom padding */\n    background: #fff;               /* Optional: your custom background */\n}\n\n.custom-dialog .p-dialog-footer {\n    background: #f1f3f6;\n    border-bottom-left-radius: 16px;\n    border-bottom-right-radius: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
